import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

/**
 * Conversation-list skeleton (SPEC-2026-07-internal-chat, T-25 · RNF-08).
 *
 * Placeholder rows (avatar + name + preview) shown while the FIRST bootstrap
 * snapshot is in flight, in place of the real list — both in the `/chat`
 * sidebar column and in the bubble popup list. Bootstrap `.placeholder`
 * utilities only: no custom colors.
 */
@Component({
  selector: 'chat-sidebar-skeleton',
  templateUrl: './chat-sidebar-skeleton.component.html',
  styleUrls: ['./chat-skeleton.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ChatSidebarSkeletonComponent implements OnInit {

  /** How many placeholder rows to render. */
  @Input() rows = 6;

  /** Compact spacing for the popup (390px wide) surface. */
  @Input() compact = false;

  /** Built once — the row count never changes while the skeleton is mounted. */
  rowList: number[] = [];

  ngOnInit(): void {
    const total = Math.max(1, Math.min(this.rows, 20));
    this.rowList = Array.from({ length: total }, (_unused, index) => index);
  }
}
